import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App.4";
import reportWebVitals from "./reportWebVitals";
import Shop from "./Shop";
import { LanguageProvider } from "./LanguageContext";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import SliderPage from "./SliderPage";

const isShop = process.env.REACT_APP_VARIATION === "shop";

ReactDOM.render(
  <React.StrictMode>
    <LanguageProvider>
      {isShop ? (
        <Shop />
      ) : (
        <BrowserRouter>
          <Switch>
            <Route exact path="/slider">
              <SliderPage />
            </Route>
            <Redirect exact from="/en" to="/?lang=en" />
            <Redirect exact from="/no" to="/?lang=no" />
            <Route>
              <App />
            </Route>
          </Switch>
        </BrowserRouter>
      )}
    </LanguageProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
